// For each polyfill
if (!Array.prototype.forEach) {

	Array.prototype.forEach = function(callback/*, thisArg*/) {

	  var T, k;

	  if (this == null) {
		throw new TypeError('this is null or not defined');
	  }

	  // 1. Let O be the result of calling toObject() passing the
	  // |this| value as the argument.
	  var O = Object(this);

	  // 2. Let lenValue be the result of calling the Get() internal
	  // method of O with the argument "length".
	  // 3. Let len be toUint32(lenValue).
	  var len = O.length >>> 0;

	  // 4. If isCallable(callback) is false, throw a TypeError exception.
	  // See: http://es5.github.com/#x9.11
	  if (typeof callback !== 'function') {
		throw new TypeError(callback + ' is not a function');
	  }

	  // 5. If thisArg was supplied, let T be thisArg; else let
	  // T be undefined.
	  if (arguments.length > 1) {
		T = arguments[1];
	  }

	  // 6. Let k be 0.
	  k = 0;

	  // 7. Repeat while k < len.
	  while (k < len) {

		var kValue;

		// a. Let Pk be ToString(k).
		//    This is implicit for LHS operands of the in operator.
		// b. Let kPresent be the result of calling the HasProperty
		//    internal method of O with argument Pk.
		//    This step can be combined with c.
		// c. If kPresent is true, then
		if (k in O) {

		  // i. Let kValue be the result of calling the Get internal
		  // method of O with argument Pk.
		  kValue = O[k];

		  // ii. Call the Call internal method of callback with T as
		  // the this value and argument list containing kValue, k, and O.
		  callback.call(T, kValue, k, O);
		}
		// d. Increase k by 1.
		k++;
	  }
	  // 8. return undefined.
	};
  }


  if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}



function updateOnMedia(mediaQuery, callback) {
	let lastValue = null

	const update = () => {
		let matches = window.matchMedia(mediaQuery).matches

		if (matches === lastValue) {
			return
		}

		if (matches) {
			callback(true)
		} else {
			callback(false)
		}

		lastValue = matches
	}

	update()
	window.addEventListener('resize', update);
}

module.exports.getFilePond = () => {
	let fp = require('filepond');
	let FilePondPluginImagePreview = require('filepond-plugin-image-preview');
	let FilePondPluginImageExifOrientation = require('filepond-plugin-image-exif-orientation');
	fp.registerPlugin(FilePondPluginImagePreview);
	fp.registerPlugin(FilePondPluginImageExifOrientation);
	return fp;
}

module.exports.showMobileMenu = () => {
	let mobileMenu = document.querySelector('.mobile-menu')
	mobileMenu.style.display = 'block'

	setTimeout(() => mobileMenu.classList.add('mobile-menu--shown'), 20);
}

module.exports.hideMobileMenu = () => {
	let mobileMenu = document.querySelector('.mobile-menu')

	mobileMenu.classList.remove('mobile-menu--shown')

	setTimeout(() => mobileMenu.style.display = 'none', 500);
}


module.exports.swapLoginInner = (e, tab) => {
	e.preventDefault()

	let innerLogin  = document.querySelector('.login-window__inner--login')
	let innerSignup = document.querySelector('.login-window__inner--signup')

	let targetContainer = tab == 'login' ? innerLogin : innerSignup
	let hideContainer = tab == 'login' ? innerSignup : innerLogin

	targetContainer.classList.add('shown')
	hideContainer.classList.remove('shown')
}

module.exports.initFeaturesPage = () => {

	let gsap = require('gsap')

	let ScrollMagic = require('scrollmagic')
	require('scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap');
	// require('scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators.js');


	var controller = new ScrollMagic.Controller({
		globalSceneOptions: {
			triggerHook: "onEnter",
			duration: "200%"
		}
	});




	new ScrollMagic.Scene({
		triggerElement: "#p-features__template-lang-section"
	})
	.setTween("#p-features__template-lang-section .p-features__template-lang-image-left", {
		y: "-60%",
		ease: Linear.easeNone
	})
	// .addIndicators()
	.addTo(controller);

	new ScrollMagic.Scene({
		triggerElement: "#p-features__template-lang-section"
	})
	.setTween("#p-features__template-lang-section .p-features__template-lang-image-right", {
		y: "-60%",
		ease: Linear.easeNone
	})
	// .addIndicators()
	.addTo(controller);



	let addonsRocket = new ScrollMagic.Scene({ triggerElement: "#p-features__addons" })
		.setTween("#p-features__addons .p-features__addons-rocket", {
			rotation: "20%",
			ease: Linear.easeNone
		})
		// .addIndicators()
		.addTo(controller);


	// Mobile friendly image 1
	let mobileFriendlyImage1Scene = new ScrollMagic.Scene({
			triggerElement: "#p-features-mobile-friendly"
		})
		.setTween("#p-features-mobile-friendly .p-features-mobile-friendly__image-1", {
			y: "80%",
			ease: Linear.easeNone
		})
		// .addIndicators()
		.addTo(controller);

	// Mobile friendly image 2
	let mobileFriendlyImage2Scene = new ScrollMagic.Scene({
			triggerElement: "#p-features-mobile-friendly"
		})
		.setTween("#p-features-mobile-friendly .p-features-mobile-friendly__image-2", {
			y: "150%",
			ease: Linear.easeNone
		})
		// .addIndicators()
		.addTo(controller);

	// // Mobile friendly image 2
	// let parallax1 = new ScrollMagic.Scene({ triggerElement: "#p-features-parallax-1", triggerHook: 0.5 })
	// .setTween("#p-features-parallax-1 #p-features-parallax-1-image", { y: "-150%", top: 150, ease: Linear.easeNone })
	// .addIndicators()
	// .addTo(controller);


	updateOnMedia('(max-width: 750px)', (matches) => {
		if (matches) {
			document.querySelector('.p-features-mobile-friendly__image-1').style.transform = ''
			document.querySelector('.p-features-mobile-friendly__image-2').style.transform = ''

			mobileFriendlyImage1Scene.remove()
			mobileFriendlyImage2Scene.remove()
			// parallax1.remove()
			// console.log('matches');
		} else {
			// console.log('does not match');
			mobileFriendlyImage1Scene.addTo(controller);
			mobileFriendlyImage2Scene.addTo(controller);
			// parallax1.addTo(controller);
		}
	})


	// Live preview animation trigger
	new ScrollMagic.Scene({
			triggerElement: ".p-features-live-preview-container",
			offset: 100,
			// reverse: false
			// duration: 10000
		})
		.setClassToggle(".p-features-live-preview-container", "js-animate-off")
		// .addIndicators()
		.addTo(controller);


	// // Animate all fade in objects
	// let fadeIns = document.querySelectorAll('.js-fade-in')

	// for (let element of fadeIns) {
	//     // build scene
	//     new ScrollMagic.Scene({
	//         triggerElement: element,
	//         triggerHook: 0.9, // show, when scrolled 10% into view
	//         duration: "80%", // hide 10% before exiting view (80% + 10% from bottom)
	//         offset: 50 // move trigger to center of element
	//     })
	//     .setClassToggle(element, "js-visible") // add class to reveal
	//     .addIndicators() // add indicators (requires plugin)
	//     .addTo(controller);
	// }

}






module.exports.initEE6Page = () => {

	let gsap = require('gsap')
	let ScrollMagic = require('scrollmagic')
	require('scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap');

	const header = document.querySelector('#ee6-fade-in-header');
	const subtitle = document.querySelector('#ee6-fade-in-subtitle');
	const download = document.querySelector('#ee-download-button');
	const mainHeader = document.querySelector('.p-ee6-header-landing');

	const image = document.querySelector('#ee6-fade-in-image');

	document.addEventListener('DOMContentLoaded', (event) => {
		var mainDelay = 0.1

		TweenLite.to(header, 4, { opacity: 1, ease: Linear.ease , delay: mainDelay});
		TweenLite.to(subtitle, 4, { opacity: 1, ease: Linear.ease, delay: mainDelay + 0.05 });
		TweenLite.to(download, 4, { opacity: 1, ease: Linear.ease, delay: mainDelay + 0.05 });

		TweenLite.fromTo(image, 1,
			{ scale: 0.95, rotateX: 100, opacity: 0, ease: Linear.ease, delay: 1 },
			{ scale: 1, rotateX: 0, opacity: 1 }
			).delay(mainDelay + 0.5);

		TweenLite.to(mainHeader, 1.5, { opacity: 1, ease: Linear.ease, delay: mainDelay + 2 });

	})


	var controller = new ScrollMagic.Controller({
		globalSceneOptions: {
			triggerHook: "onEnter",
			duration: "200%"
		}
	});

	var mobileFriendlyImage1Scene = new ScrollMagic.Scene({ triggerElement: "#p-ee6-content-trigger" })
	.setTween("#p-ee6-content", {
		// rotationY: "30%",
		y: "-200%",
		// ease: Linear.easeNone
	})
	// .addIndicators()
	.addTo(controller);

	updateOnMedia('(max-width: 750px)', (matches) => {
		if (matches) {
			document.querySelector('#p-ee6-content').classList.add('is-mobile')

			mobileFriendlyImage1Scene.remove()
		} else {
			mobileFriendlyImage1Scene.addTo(controller);
			document.querySelector('#p-ee6-content').classList.remove('is-mobile')

		}
	})
}





module.exports.initSupportPage = () => {
	document.querySelectorAll('.support-plan').forEach((plan) => {
		let planChooseContainer = plan.querySelector('.support-plan__choose-price')
		let planInfoContainer = plan.querySelector('.support-plan__info')

		let chooseBtn = plan.querySelector('.js-support-choose')
		let goBackBtn = plan.querySelector('.js-support-go-back')

		const switchTab = (tab) => {
			let targetContainer = tab == 'info' ? planInfoContainer : planChooseContainer
			let hideContainer = tab == 'info' ? planChooseContainer : planInfoContainer

			// targetContainer.style.display = 'block'
			targetContainer.classList.add('shown')
			hideContainer.classList.remove('shown')
		}

		chooseBtn.addEventListener('click', (e) => {
			e.preventDefault()
			switchTab('choose')
		})

		goBackBtn.addEventListener('click', (e) => {
			e.preventDefault()
			switchTab('info')
		})
	})
}





// Init
;
(function () {
	var getClosest = function (elem, selector) {
		for ( ; elem && elem !== document; elem = elem.parentNode ) {
			if ( elem.matches( selector ) ) return elem;
		}
		return null;
	};


	// Setup tooltips
	window.tippy = require('tippy.js')

	tippy.setDefaults({
		arrow: true,
		theme: 'eesupport',
		animation: 'fade',
		interactive: true,
	})


	// Initialize any copy buttons
	let ClipboardJS = require('clipboard')
	let clipboard = new ClipboardJS('.js-copy');

	// Show a tooltip on success
	clipboard.on('success', function (e) {
		let button = e.trigger
		showCopyNotification(button, 'Link Copied!')
		e.clearSelection();
	});

	clipboard.on('error', function (e) {
		let button = e.trigger

		showCopyNotification(button, 'Press Ctrl+C to copy')
	});

	function showCopyNotification(button, message) {
		let tooltip = button._tippy ? button._tippy : tippy(button)
		tooltip.setContent(message)
		tooltip.set({
			arrow: false,
			animation: 'shift-away',
			trigger: 'manual',
			onHidden(instance) {
				instance.destroy()
			}
		})

		tooltip.show()

		// Hide the tooltip after a second
		setTimeout(() => {
			tooltip.set({
				animation: 'fade'
			})
			tooltip.hide()
		}, 1500);
	}

	document.querySelectorAll('.js-copy').forEach((copyButton) => {
		copyButton.addEventListener('click', e => e.preventDefault())
	})


	// Initialize code highlighting
	let eeLang = require('./ee-lang.js')
	hljs.registerLanguage('ee', eeLang)

	document.addEventListener('DOMContentLoaded', (event) => {
		document.querySelectorAll('pre code').forEach((block) => {
			// Highlight to the pre element
			hljs.highlightBlock(block.parentElement)
		})
	})

	let shave = require('shave')
	shave('.js-shave', 70)

	// Initialize any carousel elements
	let Glide = require('@glidejs/glide')

	document.querySelectorAll('.glide').forEach((slider) => {
		let options = {
			type: 'carousel',
			animationDuration: 600,
		}

		if (slider.classList.contains('glide--autoplay')) {
			options.autoplay = 8000
		}

		new Glide(slider, options).mount()
	})


	// Initialize any full width text elements
	let fitty = require('fitty')
	fitty.default('.fitty', {
		minSize: 12,
		maxSize: 180
	});

	var FontFaceObserver = require('fontfaceobserver')

	var font = new FontFaceObserver('Facon');

	// When our custom fonts load, tell fitty to update
	font.load().then(() => {
		fitty.default.fitAll()
	}, () => {});

	// Initialize sticky elements
	let stickyBits = require('stickybits')
	stickyBits('.sticky', {
		useStickyClasses: true,
		stickyBitStickyOffset: 72
	});
	stickyBits('.sticky-no-offset', {
		useStickyClasses: true,
		stickyBitStickyOffset: 0
	});



	// Initialize dropdown menus
	tippy('.dropdown', {
		arrow: true,
		theme: 'dropdown',
		animation: 'fade',
		duration: [200, 150],
		role: 'tooltip',
		offset: "0, 10",
		interactive: true,
		placement: 'bottom-end',
		flipOnUpdate: true,
		trigger: 'click',
		popperOptions: {
			modifiers: {
				preventOverflow: {
					boundariesElement: 'window'
				}
			}
		},
		content(reference) {
			// Get the dropdown menu that's next to the tippy
			let template = reference.nextElementSibling
			// Make sure it is the dropdown menu
			if (!template || !template.classList.contains('dropdown__menu')) {
				return ''
			}

			return template
		},
	})

	// Prevent dropdown links for redirecting, instead of opening the dropdown
	document.querySelectorAll('.dropdown').forEach((el) => {
		el.addEventListener('click', e => e.preventDefault())
	})


	// Initialize modals
	let initModals = document.querySelectorAll('.modal')

	initModals.forEach(modal => {
		modal.addEventListener('click', e => {
			closeAllModals()
		})

		modal.querySelector('.modal__window').addEventListener('click', e => {
			e.preventDefault()
			e.stopPropagation()
		})
	})

	let modalOpenButtons = document.querySelectorAll('[data-show-modal]')

	modalOpenButtons.forEach(openButton => {
		openButton.addEventListener('click', e => {
			e.preventDefault()
			e.stopPropagation()

			let modalToOpen = openButton.dataset.showModal

			closeAllModals(modalToOpen)

			let modal = document.querySelector('.modal.' + modalToOpen)

			if (modal) {
				modal.style.display = 'block'
				setTimeout(() => {
					modal.classList.add('modal--open')
				}, 20);

				document.body.classList.add('modal-open')
			}
		})
	})

	let modalCloseButtons = document.querySelectorAll('[data-close-modal]')

	modalCloseButtons.forEach(closeButton => {
		closeButton.addEventListener('click', e => {
			e.preventDefault()
			e.stopPropagation()

			closeAllModals()
		})
	})


	function closeAllModals(excluding = '') {
		let modals = document.querySelectorAll('.modal')

		modals.forEach(modal => {
			if (modal.classList.contains(excluding)) {
				return;
			}

			modal.classList.remove('modal--open')

			setTimeout(() => {
				modal.style.display = 'none'
			}, 600);
		})

		document.body.classList.remove('modal-open')
	}



	let clickClassButtons = document.querySelectorAll('[data-click-class]')

	clickClassButtons.forEach(button => {
		button.addEventListener('click', e => {
			button.classList.add(button.dataset.clickClass)

			setTimeout(() => {
				button.classList.remove(button.dataset.clickClass)

				if (button.href) window.location = button.href;
			}, 1300);
		})
	})


	document.querySelectorAll('.toggle-link').forEach(link => {
		link.addEventListener('click', (e) => {
			e.preventDefault()

			var txtIs = link.dataset.showTxt
			var hideIs = link.dataset.hideTxt
			var toggleDivClass = link.rel

			var isShown = (link.dataset.isShown == 'true')
			var toggleDiv = document.querySelector('.'+toggleDivClass)

			if (!toggleDiv) {
				return;
			}

			link.innerText = isShown ? txtIs : hideIs
			toggleDiv.style.display = isShown ? 'none' : 'block'

			link.dataset.isShown = (!isShown) ? 'true' : 'false'
		})
	})


	document.querySelectorAll('a.submit_parent').forEach(link => {
		link.addEventListener('click', (e) => {
			e.preventDefault();

			getClosest(link, 'form').submit();
		});
	});

})();




// -------------------------------------------------------------------
// Docs
// -------------------------------------------------------------------

module.exports.initDocs = function() {
	let focusInput = document.querySelector('.js-focus-command')

	document.addEventListener("keydown", (event) => {
		if (focusInput == document.activeElement) {
			return
		}

		if (focusInput && event.keyCode == 191) {
			event.preventDefault()
			focusInput.focus()
		}
	})

	let docsMobileNav = document.querySelector('.docs-nav')
	let mobileNavSearchInput = document.querySelector('.docs-nav .search-input__input')

	document.querySelector('.docs-nav__search-button').addEventListener("click", (event) => {
		event.preventDefault()

		docsMobileNav.classList.add('search-active')
		mobileNavSearchInput.focus()
	})

	mobileNavSearchInput.addEventListener("focus", (event) => {
		docsMobileNav.classList.add('search-active')
	})

	mobileNavSearchInput.addEventListener("blur", (event) => {
		docsMobileNav.classList.remove('search-active')
	})


	var items = document.querySelectorAll('.docs-sidebar__toc li > ul');

	// Hide every toc ul that is not the active one
	for (var i = 0; i < items.length; i++) {
		;(function() {
			let item = items[i];

			item = item.closest('li');

			if (!item.classList.contains('active')) {
				closeNavItem(item);
			}

			item.addEventListener('click', function(event) {
				event.stopPropagation();
				expandNavItem(event);
			})
		})();
	}

	// Make the toc visible now that the uls have been hidden
	let sidebarToc = document.querySelector('.docs-sidebar__toc')
	if (sidebarToc) sidebarToc.style.visibility = 'visible';

	// -------------------------------------------------------------------

	var hiddenTocs = document.querySelectorAll('.table-of-contents.collapse');

	// Hide any page TOCS that need to be hidden
	for (let i = 0; i < hiddenTocs.length; i++) {
		;(function() {
			var toc = hiddenTocs[i];

			var tocButton = toc.querySelector('.toc-overview-button');
			var tocList   = toc.querySelector('ul');

			if (!tocButton || !tocList) {
				return;
			}

			tocButton.addEventListener('click', function() {
				var show = (tocList.style.display != 'block');
				tocButton.innerText  = show ? 'Hide List' : 'Show List';
				tocList.style.display = show ? 'block' : 'none';
			});

			tocList.style.display = 'none';
		})();
	}

	// -------------------------------------------------------------------

	let mobileNavButton = document.querySelector('.docs-nav__title')

	mobileNavButton.addEventListener('click', () => {
		let tocMenu = document.querySelector('.docs-sidebar-container')

		let isShown = tocMenu.classList.contains('shown')

		if (!isShown) {
			tocMenu.classList.add('shown')
			mobileNavButton.classList.add('shown')

		} else {
			tocMenu.classList.remove('shown')
			mobileNavButton.classList.remove('shown')
		}
	})


	// Scroll the active page toc item into view

	// scrollActiveTocLinkIntoView();

	// -------------------------------------------------------------------
	// Methods
	// -------------------------------------------------------------------

	// Gets the current active page item in the toc
	function getActivePage() {
		return document.querySelector('li[data-active-page="true"]');
	}

	// Expands a toc list
	function expandNavItem(e) {
		function expand (item) {
			var ul = item.getElementsByTagName('ul')[0];

			item.classList.add('active');

			if (ul) {
				ul.style.display = 'block';
			}

			var parentEl = item.parentNode.closest('li');
			if (parentEl) {
				expand(parentEl);
			}
		}

		var item = e.currentTarget;
		var itemLink = item.querySelector('a');

		// Don't close the item is it's open and the user is not clicking the item head link
		if (e.target != item && e.target != itemLink && item.className == 'active') {
			return;
		}

		if (item.className == 'active') {
			var itemList = item.querySelector('ul');

			item.classList.remove('active');

			if (itemList) {
				itemList.style.display = 'none';
			}
		} else {
			closeAllNavItems();
			expand(item);

			var activePage = getActivePage();
			if (activePage) {
				activePage.classList.add('active');
			}
		}
	}

	// Closes a toc item list
	function closeNavItem(item) {
		item.classList.remove('active');

		var ul = item.getElementsByTagName('ul')[0];
		if (ul) {
			ul.style.display = 'none';
		}
	}

	// Closes all toc lists
	function closeAllNavItems() {
		var items = document.querySelectorAll('.docs-sidebar__toc li > ul');

		for (var i = 0; i < items.length; i++) {
			var item = items[i];

			item = item.closest('li');
			closeNavItem(item);
		}
	}

	// -------------------------------------------------------------------
}


